import React from "react";

const Loading = () => {
  return (
    <section className="flex flex-col items-center justify-center gap-12 w-full h-[700px] bg-dry">
      <img
        src="/saigonstar/logo.webp"
        alt="404"
        className="w-full max-h-20 object-contain m-4 "
      />
      <span className="loader block w-4 h-4 rounded-full relative animate-flash" />
    </section>
  );
};

export default Loading;
